import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import Auth from '@/pages/Auth'
import { useRoutes } from 'react-router-dom'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/auth', element: <Auth /> },
]

function App() {
  return useRoutes(routes)
}

export default App
